import { styled, css, AccordionSummary, Link } from '@mui/material';

import ButtonContainer from '../../../components/ButtonContainer';

export const StyledNavMenuMobile = styled('nav')(
  ({ theme, open }) => css`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${theme.palette.common.white};
    overflow-y: scroll;
    transform: translate3d(0%, 0, 0);
    transition: transform 0.3s ease-in-out;
    z-index: 90;

    transform: translate3d(${open ? '0%' : '100%'}, 0, 0);

    ${theme.breakpoints.up('desktop')} {
      display: none;
    }
  `
);

export const StyledNavMenuMobileList = styled('ul')(
  ({ theme }) => css`
    list-style-type: none;
    margin-top: ${theme.shape.headerMobile};
    padding: 0;
  `
);

export const StyledNavMenuMobileMenuItem = styled('li')(
  ({ theme }) => css`
    padding: ${theme.spacing('1XL')} ${theme.spacing('LARGE')};
  `
);

export const StyledNavMenuMobileSubMenuList = styled('ul')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    list-style-type: none;
    padding: 0;
    row-gap: ${theme.spacing('SMALL')};
  `
);

export const StyledSeparator = styled('div')(
  ({ theme }) => css`
    background-color: ${theme.palette.gray.light_gray};
    border: none;
    height: 1px;
    margin: 0;
    width: 100%;
  `
);

export const StyledNavMenuAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => css`
    &.Mui-expanded {
      margin: '0';
      color: ${theme.palette.text.navMenuLinkHover};

      svg > path {
        stroke: ${theme.palette.text.navMenuLinkHover};
      }
    }
  `
);

export const StyledNavMenuMobileItemLink = styled(Link)(
  ({ theme }) => css`
    align-items: center;
    color: ${theme.palette.main.professional_blue};
    column-gap: ${theme.spacing('SMALL')};
    display: flex;
    text-decoration: none;

    &:hover {
      color: ${theme.palette.text.navMenuLinkHover};
    }

    &:active {
      text-decoration: underline;
    }

    &.Mui-focusVisible {
      text-decoration: underline;
    }
  `
);

export const StyledNavMenuMobileSubMenuCardContent = styled('div')(
  ({ theme }) => css`
    align-items: center;
    border: 1px solid ${theme.palette.gray.light_gray};
    border-radius: 4px;
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    padding: ${theme.spacing('1XL')} ${theme.spacing('LARGE')};
  `
);

export const StyledSignoutButtonContainer = styled(ButtonContainer)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing('1XL')};
    padding-left: ${theme.spacing('LARGE')};
    padding-right: ${theme.spacing('LARGE')};
  `
);
